import { createStyles } from 'antd-style'

export const useStyle = createStyles(({ token }) => ({
  serviceRow: {
    padding: '10px 12px',
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadius
  },
  serviceRowSelected: {
    borderColor: token.colorPrimary
  }
}))
